import { createContract, createEthereumJsTx } from '@exodus/ethereum-lib'
import { bufferToHex } from '@exodus/ethereumjs/util'
import assert from 'minimalistic-assert'

import { fromHexToBigInt } from '../number-utils.js'

export const estimateL1DataFeeFactory = ({ l1GasOracleAddress, server }) => {
  assert(l1GasOracleAddress, 'l1GasOracleAddress is required')
  assert(server, 'server is required')
  const gasContract = createContract(l1GasOracleAddress, 'optimismGasOracle')
  return async ({ unsignedTx }) => {
    const ethjsTx = createEthereumJsTx(unsignedTx)
    const serialized = ethjsTx.serialize()
    const callData = gasContract.getL1Fee.build(serialized)
    const buffer = Buffer.from(callData)
    const data = bufferToHex(buffer)
    const hex = await server.ethCall({ to: l1GasOracleAddress, data }, 'latest')
    const l1DataFee = fromHexToBigInt(hex)
    const padFee = l1DataFee / BigInt(4)
    const maxL1DataFee = l1DataFee + padFee
    return maxL1DataFee.toString()
  }
}

export const getL1GetFeeFactory = ({ asset, originalGetFee }) => {
  return ({ feeOpts, ...args }) => {
    const { fee, ...rest } = originalGetFee(args)
    if (!feeOpts?.optimismL1DataFee) {
      // hardcoded optimism name is for back compatiblity, it could be base!
      // better to rename
      return { fee, ...rest }
    }

    const l1DataFee = asset.currency.baseUnit(feeOpts.optimismL1DataFee)
    return { fee: fee.add(l1DataFee), ...rest }
  }
}
